/** ===================================================================
 *  Bestdealdepot: doAnimation.js v1.1.0
 *  
 *  Common animations plugin
 *  ===================================================================
 */
+function($, window, document) {
	'use strict';
	
	var options = {
		'scroll_duration': 200	
	};
	
	//scroll to 
	$.scrollTo = function(top, callback) {
		if ($.type(callback) == 'function') {
			$('html,body').animate({scrollTop: top}, {duration: options.scroll_duration, queue: false, complete: callback});
		}else {
			$('html,body').animate({scrollTop: top}, {duration: options.scroll_duration, queue: false});
		}
	};
}(jQuery, window, document);